/**
 * @module events/types/dragEnter
 */

/**
 * @type {string}
 */
export default 'dragenter'
